import { Component, OnDestroy } from "@angular/core";
import { AdminMenusService } from "../admin-sidebar/admin-menus.service";
import { ApiserviceService } from "../../../../src/app/apiservice.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { environment } from "../../../../src/environments/environment";
import { NotificationService } from "../services/notification.service";
import { CommonfunctionService } from "../../../../src/app/services/commonfunction.service";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
  selector: "app-admin-visibility-calculation",
  templateUrl: "./admin-visibility-calculation.component.html",
  styleUrls: ["./admin-visibility-calculation.component.scss"],
})
export class AdminVisibilityCalculationComponent implements OnDestroy {
  eps_log_path = environment.epsUrl + "download-file?file_url="; //+ environment.eps_log_path;
  propertyList: any;
  startYear: number;
  currentYear: number = new Date().getFullYear();
  visibilityFormGroup: FormGroup;
  loading = false;
  offset: number = 0;
  limit: number = 10;
  totalCount: number;
  private subs = new Subscription();
  // selectedProperty: any;
  layerOptionList = [
    { value: "observer_visibility", label: "Observer Visibility" },
    { value: "outside_visibility", label: "Outside Visibility" },
    { value: "inside_visibility", label: "Inside Visibility" },
    // { value: "calculate_direction", label: "Calculate Direction" },
  ];
  propertyListOptions: {
    [x: string]: any;
    value: any;
    label: string;
    searchText: string;
  }[] = [];
  visibility_calculation_access = {
    GET: false,
    POST: false,
    PATCH: false,
    DELETE: false,
  };
  statusMap = {
    "-1": { label: "Invalid", color: "#FF4A4A" },
    "1": { label: "Valid", color: "#81A2FF" },
    "2": { label: "Accepted", color: "#0FEB03" },
    "-2": { label: "Accept Invalid", color: "#E3DB05" },
    "0": { label: "Uploaded", color: "#AAAAAA" },
    "-3": { label: "Stopped", color: "#FF4A4A" },
    "4": { label: "Accept Progress", color: "#FF8A3E" },
    "3": { label: "Validating", color: "#ACA710" },
  };

  // Buttons configuration
  buttonConfig = {
    log: [
      {
        label: "Log",
        action: (element) => this.validateLog(element),
        style: {
          hover: {
            "background-color": "#e0e8ff",
          },
          disabled: {
            color: "gray",
            "background-color": "#f0f0f0",
          },
        },
        class: "log-button",
      },
      // {
      //   label: "Accept Log",
      //   action: (element) => this.acceptLog(element),
      //   style: {
      //     hover: {
      //       "background-color": "#d0ffd0",
      //     },
      //     disabled: {
      //       color: "darkgray",
      //       "background-color": "#e0e0e0",
      //     },
      //   },
      //   class: "log-button",
      // },
      {
        label: "Error Log",
        action: (element) => this.errorLog(element),
        style: {
          hover: {
            "background-color": "#d0ffd0",
          },
          disabled: {
            color: "darkgray",
            "background-color": "#e0e0e0",
          },
        },
        class: "log-button",
      },
      {
        label: "Accept Error",
        action: (element) => this.errorAcceptLog(element),
        style: {
          hover: {
            "background-color": "#d0ffd0",
          },
          disabled: {
            color: "darkgray",
            "background-color": "#e0e0e0",
          },
        },
        class: "log-button",
      },
    ],
    action: [
      // {
      //   label: "Accept",
      //   action: (element) => this.acceptAndReject(element, "accept"),
      //   style: {
      //     border: "1px solid #008000",
      //     color: "green",
      //     padding: "5px 10px",
      //     width: "100px",
      //     "background-color": "#eaffea",
      //     hover: {
      //       "background-color": "#d9ffd9",
      //     },
      //     disabled: {
      //       color: "#808080",
      //       background: "red",
      //     },
      //   },
      // },
      {
        label: "Stop Process",
        action: (element) => this.acceptAndReject(element, "reject"),
        style: {
          border: "1px solid #ff0000",
          color: "red",
          padding: "5px 10px",
          width: "100px",
          "background-color": "#ffeaea",
          hover: {
            "background-color": "#ffdada",
          },
          disabled: {
            color: "darkred",
            "background-color": "#e0e0e0",
          },
        },
        // disabled: (element) => element.status !== '1', // Disable if status is not "Valid"
      },
    ],
  };
  selectedColumns: string[] = [
    "upload_id",
    "file_name",
    "added_by",
    "added_date",
    "accept_time",
    "accept_date",
    "validate_time",
    "updated_date",
    "updated_by",
    "status",
    "log",
    "action",
  ];
  selectedData: any[] = [];
  selectedLayer: string;
  constructor(
    private readonly menus: AdminMenusService,
    private readonly api: ApiserviceService,
    private readonly fb: FormBuilder,
    private readonly notify: NotificationService,
    private readonly fnc: CommonfunctionService,
    private readonly route: Router
  ) {
    this.menus.setActive("visibility-calculation");
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.getAllowResourcesApi();
    this.visibilityFormGroup = this.fb.group({
      propertyDetailsControl: ["", Validators.required],
      layerName: ["", Validators.required],
      // propertyValueName: [""],
    });
    this.setDefaultValue();
  }
  onLayerSelection(event) {
    console.log(event);
    this.selectedLayer = event;
    this.getCalcutionData();
    this.showDownloadOption();
  }
  showDownloadOption() {
   const downloadIndex = this.buttonConfig.action.findIndex(
    (btn) => btn.label === "Download"
  );

  if (this.selectedLayer === "observer_visibility") {
    // Add if not already present
    if (downloadIndex === -1) {
      this.buttonConfig.action.push({
        label: "Download",
        action: (element) => this.downloadFile(element),
        style: {
          border: "1px solid #008000",
          color: "green",
          padding: "5px 10px",
          width: "100px",
          "background-color": "#eaffea",
          hover: {
            "background-color": "#d9ffd9",
          },
          disabled: {
            color: "#808080",
            "background-color": "red",
          },
        },
        // disabled: (element) => element.status !== '1',
      });
    }
  } else {
    // Remove if it exists
    if (downloadIndex !== -1) {
      this.buttonConfig.action.splice(downloadIndex, 1);
    }
  }
  }

  setDefaultValue() {
    if (!this.selectedLayer && this.layerOptionList.length > 0) {
      this.selectedLayer = this.layerOptionList[0].value;
       this.showDownloadOption();
    }

    this.visibilityFormGroup.patchValue({
      layerName: this.selectedLayer,
    });

    this.getPropertyDetails();
  }

  // setDefaultValue() {
  //   if (!this.selectedLayer && this.layerOptionList.length > 0) {
  //     this.selectedLayer = this.layerOptionList[0].value;
  //   }

  /**
   * Fetches allowed resources from the API and sets access rights.
   */
  getAllowResourcesApi() {
    let body = `user/resource?place_id=${this.api.city_id}&user_id=${this.api.user_id}`;
    const allowResSub = this.api.getUmsData(body).subscribe({
      next: (res: any) => {
        this.api.allowResources = res.data;
        this.getAllowResource();
      },
      error: (err) => {},
    });
    this.subs.add(allowResSub);
  }

  /**
   * Sets access rights for attribute deletion and navigates if access is denied.
   */
  getAllowResource() {
    this.visibility_calculation_access = this.fnc.checkResourceAccess(
      "visibility_calculation",
      false
    );
    if (!this.visibility_calculation_access.GET) {
      this.route.navigateByUrl("");
    } else {
      this.getPropertyDetails();
      this.getCalcutionData();
    }
  }

  getPropertyDetails() {
    let url = `calculation-properties?layer=unit&limit=1000`;
    const propDetailsSub = this.api.getEpsData(url).subscribe({
      next: (res: any) => {
        this.propertyList = res.data;
        // Prepare your options like this:
        this.propertyListOptions = this.propertyList.map((item) => ({
          value: item.prop_id,
          label: item.prop_mame ? `${item.uid} - ${item.prop_mame}` : item.uid, // Displayed in dropdown
          searchText: `${item.uid} ${item.prop_mame}`.toLowerCase(),
        }));
      },
      error: (err) => {},
    });
    this.subs.add(propDetailsSub);
  }

  // onPropertySelection(selectedPropId: any) {
  //   // Find the selected property
  //   this.selectedProperty = this.propertyList.find(prop => prop.prop_id == selectedPropId) || null;
  //   // Update the form with the selected property's name
  // if (this.selectedProperty) {
  //   this.visibilityFormGroup.patchValue({
  //     propertyValueName: this.selectedProperty.prop_mame
  //   });
  // }
  // else {
  //   this.visibilityFormGroup.patchValue({
  //     propertyValueName: ''
  //   });
  // }
  // }

  // onLayerSelection(event){
  //  console.log(event);
  //  this.selectedLayer = event;
  //  this.getCalcutionData()
  // }
  calculate() {
    if (!this.visibility_calculation_access.POST) {
      this.notify.notify(
        "Access Denied: You are not authorized for this operation",
        "warn"
      );
      return;
    }
    let url = "calculate-visibility";
    let body = {
      property_id: this.visibilityFormGroup.value.propertyDetailsControl,
      floor_id: null,
      observer_ids: [],
      radius: null,
      layer: this.selectedLayer,
      user_id: this.api.user_id,
      year: this.currentYear,
      name: this.selectedLayer,
    };
    this.loading = true;
    const calculateSub = this.api.postEpsData(url, body).subscribe({
      next: (res: any) => {
        if (res.status == 200) {
          console.log(res);
          this.loading = false;
          this.notify.notify(res.message, "success");
          this.getCalcutionData();
        } else {
          this.loading = false;
          this.notify.notify(res.message, "warn");
        }
      },
      error: (err) => {
        this.loading = false;
      },
    });
    this.subs.add(calculateSub);
  }
  downloadFile(element = null) {
    console.log(element);

    if (!this.visibility_calculation_access.POST) {
      this.notify.notify(
        "Access Denied: You are not authorized for this operation",
        "warn"
      );
      return;
    }
    let url = `calculation-download?&property_id=${this.visibilityFormGroup.value.propertyDetailsControl}&upload_id=${element.upload_id}`;
    const downloadSub = this.api.getEpsData(url).subscribe({
      next: (res: any) => {
        console.log(res);
        let exportFileUrl = `${
          environment.epsUrl
        }visibility-download-file?city_code=${this.api.city_code.toLowerCase()}&file_name=${
          res.data
        }`;
        window.open(exportFileUrl, "_blank");
      },
      error: (err: any) => {},
    });
    this.subs.add(downloadSub);
  }
  pageChangeAction(event) {
    console.log(event);
    this.limit = event.limit;
    this.offset = event.offset;
    this.getCalcutionData();
  }
  getCalcutionData() {
    let url = `get-calculation-list?layer=${this.selectedLayer}&year=${this.currentYear}&is_count=true&limit=${this.limit}&offset=${this.offset}`;
    this.loading = true;
    const calDataSub = this.api.getEpsData(url).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.status == 200) {
          console.log("Calculation Data:", res.data);
          this.selectedData = [...res.data]; // Create a new reference
          this.notify.notify(res.message, "success", 5000);
          this.totalCount = res.data[0]?.count ?? 0;
        } else {
          this.notify.notify(res.message, "warn");
          this.selectedData = []; // Reset data if needed
          this.totalCount = 0;
        }
      },
      error: (err: any) => {
        this.selectedData = [];
        this.totalCount = 0;
        this.loading = false;
      },
    });
    this.subs.add(calDataSub);
  }

  acceptAndReject(element, action) {
    if (!this.visibility_calculation_access.PATCH) {
      this.notify.notify(
        "Access Denied: You are not authorized for this operation",
        "warn"
      );
      return;
    }
    let url = `calculation-upload-action?user_id=${this.api.user_id}&action=${action}&upload_id=${element.upload_id}`;
    this.loading = true;
    const acceptSub = this.api.getEpsData(url).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.status == 200) {
          console.log(res);
          this.notify.notify(res.message, "success");
          this.getCalcutionData();
        } else {
          this.notify.notify(res.message, "warn");
          this.loading = false;
        }
      },
      error: (err: any) => {
        this.loading = false;
      },
    });
    this.subs.add(acceptSub);
  }
  validateLog(element) {
    this.downloadLog(`_visibility_validate_${element.upload_id}.log`);
  }

  acceptLog(element) {
    this.downloadLog(`_visibility_accept_${element.upload_id}.log`);
  }
  errorAcceptLog(element) {
    this.downloadLog(`_visibility_accept_${element.upload_id}_err.log`);
  }
  errorLog(element) {
    this.downloadLog(`_visibility_validate_${element.upload_id}_err.log`);
  }

  /**
   * log file is downloading here
   * @param log_url
   */
  downloadLog(type) {
    let log_url = `${
      this.eps_log_path
    }${this.api.city_code.toLocaleLowerCase()}${type}`;
    console.log(log_url, "log_url", this.eps_log_path);

    window.open(log_url.toString(), "_blank");
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
